<!--
  BEWARE!
  There are 2 types of banners available here, bannersSmall and bannersLarge.
  The difference is the size of the image:
      1. When there is only one banner available the type bannersLarge is used.
      2. When there are 2 banners available, the type bannersSmall is used, so the 2 banners can be positioned next to each other in the layout.
   In BOTH cases, you want to show the MoleculeCardCover with size="extraSmall" on xs and sm breakpoints
   and MoleculeCardCover with size="medium" on the remaining md, lg, xl and 2xl breakpoints.
-->
<template>
  <section v-if="banners.length" class="container mx-auto grid grid-cols-2 2xl:grid-cols-12 gap-4 sm:gap-5 lg:gap-8 v-page-section-container-padding">
    <div
      v-for="(banner, index) in banners"
      :key="index"
      v-viewport.25%.no-out.once="({ el }: { el?: Element | null }) => onViewport({ el, banner })"
      :class="{
        'col-span-full 2xl:col-span-10 2xl:col-start-2': banners.length === 1,
        'col-span-1 2xl:col-span-5': banners.length === 2,
        '2xl:col-start-2': index === 0,
      }"
    >
      <MoleculeCardCover
        class="flex md:hidden h-full"
        :title="banner.title"
        :subtitle="banner.subtitle"
        :image="banner.image"
        :image-lazy="false"
        :url="banner.buttonUrl"
        size="extraSmall"
        @click="(event: Event) => onClick({ el: event.target as HTMLElement | null, banner })"
      />
      <MoleculeCardCover
        class="hidden md:flex h-full"
        :title="banner.title"
        :subtitle="banner.subtitle"
        :image="banner.image"
        :image-lazy="false"
        :url="banner.buttonUrl"
        size="medium"
        @click="(event: Event) => onClick({ el: event.target as HTMLElement | null, banner })"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  bannersSmall: { type: Array as PropType<any[]>, required: true },
  bannersLarge: { type: Array as PropType<any[]>, required: true },
})

const banners = props.bannersSmall.length === 2 ? props.bannersSmall : props.bannersLarge
const getPosition = (el?: Element | null) => (el?.getBoundingClientRect()?.top || 0) + (window.pageYOffset || 0)

const promoView = setupGtmPromoView()
const onViewport = ({ el, banner }: { el?: Element | null; banner: CmsData }) =>
  promoView([
    {
      name: banner.title,
      creative: banner.subtitle,
      position: getPosition(el),
    },
  ])

const promoClick = setupGtmPromoClick()
const onClick = ({ el, banner }: { el?: Element | null; banner: CmsData }) => {
  promoClick([
    {
      name: banner.title,
      creative: banner.subtitle,
      position: getPosition(el),
    },
  ])
}
</script>
